import React, { useState, useEffect } from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";

import { apiDelete, apiGet, apiPost, apiPut } from "../../api/server"

const MembersList = (props) => {
  
    const [inputEmail, setInputEmail] = useState()
    const [foundMember, setFoundMember] = useState()
    const [amount, setAmount] = useState()
    const [welcomeCall, setWelcomeCall] = useState()
    const [description, setDescription] = useState()
    const [error, setError] = useState()

    function findMember(){
      apiGet(`intranetmembers/getmemberbalancetransactionsbyemailnew/?email=${inputEmail.toLowerCase()}`).then(res => {
        res.json().then(data => {
          setFoundMember(data)
          setWelcomeCall(data.member ? data.member.welcomecall : false)
          console.log(data)
        })
      })
    }

    function changeWelcomeCall(val, auth0sub){
      apiPost(`intranetmembers/updatewelcomecall`, {val: val, auth0sub: auth0sub}).then(res => {

      })
    }

    function addCredit(){
      if(amount && description && Number.isInteger(amount*100)){
        const body = {
          amount: amount * 100,
          creditReason: description,
          auth0sub: foundMember.member.auth0sub,
        }
        apiPut(`intranetmembers/addcredit`, body).then(res => {
          res.json().then(result => {
            setFoundMember(false)
            apiGet(`intranetmembers/getmemberbalancetransactionsbyemailnew/?email=${inputEmail}`).then(res => {
              res.json().then(data => {
                setFoundMember(data)
              })
            })

          })
        })
      }else{
        setError(true)
      }
    }

    function deleteCredit(id){
      const body = {
       id: id
      }
      apiDelete(`intranetmembers/deletecredit`, body).then(res => {
        setFoundMember(false)
            apiGet(`intranetmembers/getmemberbalancetransactionsbyemailnew/?email=${inputEmail}`).then(res => {
              res.json().then(data => {
                setFoundMember(data)
              })
            })
      })
    }

    return (
        <>
        
          <Container>
            <Row>
              <Col>
                <h1>Member Credits</h1>

                  <Form.Group controlId="exampleForm.InputEmail">
                    <Form.Label>Member Email</Form.Label>
                    <Form.Control onChange={(event) => setInputEmail(event.target.value)} value={inputEmail}>

                    </Form.Control>
                  </Form.Group>
                  <Button onClick={findMember}>
                    Find Member
                  </Button>
                  <a href={`https://business-butler-intranet.herokuapp.com/`} className="btn btn-primary">
                    Home Page
                  </a>

              </Col>
            </Row>
            {foundMember && foundMember.member && <><Row>
              {foundMember && foundMember.member && foundMember.member.stripecustomerid && <>
                
                <div className="section">
                  <Form.Check 
                    type={"checkbox"}
                    label={"Has Received Welcome Call"}
                    id={"welcome-call-checkbox"}
                    checked={welcomeCall}
                    onChange={(event) => {setWelcomeCall(event.target.checked); changeWelcomeCall(event.target.checked, foundMember.member.auth0sub)}}
                  />
                  <h3>Add Credit</h3>
                  <Form.Group controlId="exampleForm.InputEmail">
                    <Form.Label>Amount (eg. 10.00)</Form.Label>
                    <Form.Control onChange={(event) => setAmount(event.target.value)} value={amount}>

                    </Form.Control>
                  </Form.Group>
                  <Form.Group controlId="exampleForm.InputEmail">
                    <Form.Label>Reason for Credit</Form.Label>
                    <Form.Control onChange={(event) => setDescription(event.target.value)} value={description}>

                    </Form.Control>
                  </Form.Group>
                  <Button onClick={addCredit}>
                  Add Credit
                  </Button>
                  {error && <div style={{color: "red"}}>Please add an amount and reason</div>}
                </div>
              </>}
            </Row>
            <Row>
              {foundMember && <div className="section">
                {foundMember.freeagentid ?
                  <>This member has a freeagent ID.  Give credits through there rather than here</>
                : <>
                  <h3>Previous Credits</h3>
                  <Table>
                    <tr>
                      <th>Amount Given</th>
                      <th>Amount Left</th>
                      <th>Date Given</th>
                      <th>Expiry Date</th>
                      <th>Reason</th>
                    </tr>
                    {foundMember && foundMember.balanceTransactions.map(item => {
                      console.log(item)
                      const created = new Date(item.date)
                      const expiry = new Date(item.expiry_date)
                      return <tr>
                        <td>£{item.amount / 100}</td>
                        <td>£{item.amount_left / 100}</td>
                        <td>{created.toDateString()}</td>
                        <td>{expiry.toDateString()}</td>
                        <td>{item.credit_reason}</td>
                        <td>{!(item.expired_used) && (item.amount === item.amount_left) && <Button onClick={() => deleteCredit(item.id)}>Delete</Button>}</td>
                      </tr>
                    })}
                  </Table>
                </>}
              </div>}
            </Row></>}
            {foundMember && foundMember.error && <div className="section"><p>{foundMember.error}</p></div>}

            <Row>
            <div className="section">
              <h2>Credit Rules</h2>
              <ul>
                <li>A member can only use a credit on a service once</li>
                <li>If they want to try out multiple products use credit on a membership tier </li>
                <li>Cannot use credit on Network pass (as we have to pay for this)</li>
                <li>Credits are valid for 1 month after welcome call (reduced from 3 to create urgency)</li>
                <li>Welcome call credit is limited to one per business  </li>
              </ul>
              </div>
            </Row>
            
            </Container>

            
        </>
      );

}

export default MembersList;